import React, { useState } from "react";
import MainContainer from "../components/container/MainContainer";
const banner_image = "/images/Folsom-fairoaks-wide-2.jpg";

const aboutSection = [
  {
    title: "PFAS Technical Assistance Program",
    paragraphs: [
      <>
        This program provides technical assistance to water systems for
        collecting and analyzing drinking water well samples for Per-and
        Polyfluoroalkyl Substances (PFAS) at all wells serving disadvantaged
        communities and severely disadvantaged communities, as required by State
        Water Board Order DW 2024-0002-DDW. Sampling and analysis services are
        provided by the Office of Water Programs and our partners at no cost to
        the water systems. All drinking water wells will be sampled at least
        once. A second round of sampling will be decided by the State Water
        Board after the first round of sampling is complete.
      </>,
    ],
  },
  {
    title: "Sampling Services",
    paragraphs: [
      <>
        Sampling services will be provided by our subcontractor Geosyntec, who
        will collect water samples from the water systems in compliance with EPA
        Method 533 and other planned methods, with the monitoring protocols of
        the State Water Board, and within the sample count limitations of the
        analytical laboratory provided by the State Water Board. The sample
        collection date and well access will be coordinated with the water
        system.
      </>,
      <>
        Analysis will be provided by Babcock Laboratories, who are directly
        contracted to the State Water Board.
      </>,
      <>
        Data will be reported by the laboratory to the State Water Board and to
        OWP. OWP will share results with the water systems, along with necessary
        actions based on the results of the analysis.
      </>,
    ],
  },
  {
    title: "Website Features",
    paragraphs: [
      <>
        The project website will allow water systems to assign staff for
        scheduling, assign staff for well access, view the pending sampling
        appointments, and view results. For questions directly regarding Order
        DW 2024-0002-DDW, please contact State Water Board’s Division of
        Drinking Water. For questions about the sampling and testing, email the
        Office of Water Programs at&nbsp;
        <a href="mailto:pfas@owp.csus.edu">pfas@owp.csus.edu</a>. Do not contact
        Babcock Laboratories directly.
      </>,
    ],
  },
];
const About = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <section className="my-8 text-primary w-full">
        <img
          src={banner_image}
          alt="fairoaks"
          className={`transition-opacity duration-500 ease-in-out
            ${
              isLoading ? "opacity-0" : "opacity-100"
            } h-[430px] w-full object-cover mb-[25px] rounded-[0.75rem] `}
          onLoad={() => setIsLoading(false)}
        />

        <h1 className="text-2xl md:text-3xl font-bold md:ml-8">About</h1>
        {aboutSection.map((obj) => {
          return (
            <MainContainer header={obj.title}>
              <div className="text-sm md:text-base font-semibold my-4 text-gray-600">
                {obj.paragraphs.map((para, index) => (
                  <>
                    <h2 key={index}>{para}</h2> <br />
                  </>
                ))}
              </div>
            </MainContainer>
          );
        })}
      </section>
    </>
  );
};

export default About;
